import { Drawer } from "antd";
import close from "./../../../../assets/images/close-outline.svg";
import { LangSpecificMsg } from "../../utils/constants";
import { ValidLanguages } from "../../utils/types";

const RestartPopup = ({ show, closePopup, handleBack, selectedLang }: any) => {
  const LangSpecificMsgData =
    LangSpecificMsg[(selectedLang as ValidLanguages) || "english"];

  return (
    <Drawer
      placement="bottom"
      onClose={closePopup}
      closeIcon={false}
      open={show}
      height="auto"
      className="rounded-t-2xl overflow-hidden max-w-[450px] mx-auto"
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-lg">
            {LangSpecificMsgData.restart}
          </div>
          <img src={close} alt="close" onClick={closePopup} />
        </div>
      </div>
      <div className="text-base py-2">{LangSpecificMsgData.deleteInfo}</div>
      <section className="flex justify-center gap-5 mt-6 w-full text-base font-medium tracking-normal leading-loose text-center">
        <button
          className={`flex justify-center overflow-hidden gap-2 self-stretch px-14 py-2 text-indigo-600 bg-white whitespace-nowrap rounded-xl border border-indigo-600 border-solid`}
          aria-label={"Yes, Restart"}
          onClick={handleBack}
        >
          {LangSpecificMsgData.yesRestart}
        </button>
        <button
          className={`flex justify-center overflow-hidden gap-2 self-stretch px-14 py-2 text-white bg-indigo-600 whitespace-nowrap rounded-xl border border-indigo-600 border-solid`}
          aria-label={"Cancel"}
          onClick={closePopup}
        >
          {LangSpecificMsgData.cancel}
        </button>
      </section>
    </Drawer>
  );
};

export default RestartPopup;
